(ns manage.adset-decision-tree-page.ad-variant-table-ocp.csv
  (:require [clojure.set :as set]
            [clojure.string :as str]
            [common.db.effects.csv :as csv-fx]
            [manage.adset-decision-tree-page.ad-variant-table-ocp.columns :as cols]))

(defn build-csv-mapping [columns]
  (let [impression-cols (cols/impression-columns columns)
        fixed-cols (remove cols/impression-field? columns)]
    (-> [[:id "ID"] [:adVariant "Content ID"] [:decisionPath "Decision Path"] [:dimensions "Dimensions"]]
        (into (map-indexed (fn [i field] [(keyword field) (str "Impression Tracker " (inc i))])
                           impression-cols))
        (into (map (fn [field] [(keyword field) (cols/fixed-column-headers field)]) fixed-cols)))))

(defn download-csv [rows columns]
  (csv-fx/download-csv (csv-fx/->csv rows (build-csv-mapping columns)) "bulk-edit-trackers"))

(defn- unquote-field [s]
  (if (and (str/starts-with? s "\"")
           (str/ends-with? s "\""))
    (-> (subs s 1 (dec (count s)))
        (str/replace "\"\"" "\""))
    (let [s (cond-> s
              (str/starts-with? s "'")
              (subs 1))]
      s)))

(defn- split-csv-line [line]
  (let [{:keys [fields current]}
        (reduce
         (fn [{:keys [current fields in-quotes pending-quote] :as state} c]
           (cond
             (and pending-quote (= c \") in-quotes)
             (assoc state :current (str current \") :pending-quote false)
             pending-quote
             (let [s (assoc state :in-quotes false :pending-quote false)]
               (if (= c \,) (assoc s :current "" :fields (conj fields current))
                   (update s :current str c)))
             (= c \") (if in-quotes
                        (assoc state :pending-quote true)
                        (assoc state :in-quotes true))
             (and (= c \,) (not in-quotes))
             (assoc state :current "" :fields (conj fields current))
             :else (update state :current str c)))
         {:current "" :fields [] :in-quotes false :pending-quote false}
         line)]
    (conj fields current)))

(defn parse-csv [csv-text]
  (let [lines (->> (str/split csv-text #"\r?\n") (remove str/blank?))
        header (first lines)
        headers (mapv unquote-field (split-csv-line header))]
    (->> (rest lines)
         (mapv (fn [line]
                 (zipmap headers (map unquote-field (split-csv-line line))))))))

(defn needed-impression-columns [parsed-csv-rows existing-columns]
  (let [headers (when (seq parsed-csv-rows) (keys (first parsed-csv-rows)))
        csv-impression-count (->> headers
                                  (filter #(str/starts-with? % "Impression Tracker"))
                                  count)
        needed (- csv-impression-count (count existing-columns))]
    (mapv (fn [_] (str "impressionTrackers-" (random-uuid))) (range (max 0 needed)))))

(defn needed-fixed-columns [parsed-csv-rows existing-columns]
  (let [headers (set (when (seq parsed-csv-rows) (keys (first parsed-csv-rows))))
        existing (set existing-columns)]
    (->> cols/normal-fixed-columns
         (filter #(contains? headers (:header %)))
         (map :field)
         (remove existing)
         vec)))

(defn apply-csv-to-rows
  [^js current-rows parsed-csv-rows impression-columns]
  (let [id->csv-row (->> parsed-csv-rows
                         (reduce (fn [m row] (assoc m (get row "ID") row)) {}))
        header->field
        (into (set/map-invert cols/fixed-column-headers)
              (map-indexed (fn [i col] [(str "Impression Tracker " (inc i)) col]) impression-columns))]
    (.map current-rows
          (fn [^js row]
            (if-let [csv-row (get id->csv-row (.-id row))]
              (let [updated (js/Object.assign #js {} row)]
                (doseq [[k v] csv-row]
                  (when (seq v)
                    (when-let [field (header->field k)]
                      (aset updated field v))))
                updated)
              row)))))

